import React, { Component } from "react";
import BsySLoading from "../../BsySLoading";
import { TriggerComboCheckPane } from "../../BsySelectCheckBox";
import BsyMsgBubble from "../../BsyMsgBubble";
import { BsyUtils } from "../../../utils/Utils";
import { BsyConfig } from "../../../global/BsyConfig";

import "./index.css";
import BsyFormPane from "../../BsyFormPane";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsyAlert from "../../BsyAlert";
import TextWidgetFilter from "../../../utils/WidgetFilter/TextWidgetFilter";
import NumberWidgetFilter from "../../../utils/WidgetFilter/NumberWidgetFilter";
import DatetimeWidgetFilter from "../../../utils/WidgetFilter/DatetimeWidgetFilter";
import ComboCheckWidgetFilter from "../../../utils/WidgetFilter/ComboCheckWidgetFilter";
import TextareaWidgetFilter from "../../../utils/WidgetFilter/TextareaWidgetFilter";
import AddressWidgetFilter from "../../../utils/WidgetFilter/AddressWidgetFilter";
import UserWidgetFilter from "../../../utils/WidgetFilter/UserWidgetFilter";
import DeptWidgetFilter from "../../../utils/WidgetFilter/DeptWidgetFilter";
import DeptGroupWidgetFilter from "../../../utils/WidgetFilter/DeptGroupWidgetFilter";
import UserGroupWidgetFilter from "../../../utils/WidgetFilter/UserGroupWidgetFilter";
import SignatureWidgetFilter from "../../../utils/WidgetFilter/SignatureWidgetFilter";
import FileListWidgetFilter from "../../../utils/WidgetFilter/FileListWidgetFilter";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { dayjsUtils } from "../../../utils/dayjsUtils";
import { getAfterSuffix } from "../../../utils/getAfterSuffix";

class BsyDashCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataList: [],
      headerList: [],
      page: 0,
      count: 0,
      fields: props.fields,
      defaultSort: props.defaultSort ? props.defaultSort : props.sort,
      limit: 30,
      isLoading: true,
      card_image: {},
      card_top_left: {},
      card_top_right: {},
      card_bottom_left: {},
      card_bottom_right: {},
    };
    this.cardCont = React.createRef();
    this.FILTER_METHOD = {
      EQ: "eq",
      NE: "ne",
      ALL: "all",
      IN: "in",
      NIN: "nin",
      LK: "like",
      ULK: "unlike",
      EP: "empty",
      NEP: "not_empty",
      GT: "gt",
      GTE: "gte",
      LT: "lt",
      LTE: "lte",
      RG: "range",
      NONE: "none",
      VF: "verified",
      NVF: "unverified",
      FM: "formula",
      FT: "filter",
    };
  }

  componentDidMount() {
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    this._getFiels();
    if (this.cardCont && this.cardCont.current) {
      this.cardCont.current.addEventListener("scroll", this.scrollFunc, false);
    }
  }

  scrollFunc = (event) => {
    if (!event.srcElement.scrollTop) {
      return;
    }
    const { page, isLoading, dataList, count } = this.state;

    const scrollTop = event.srcElement.scrollTop;
    // 视窗高度
    const clientHeight = event.srcElement.clientHeight;
    // 页面高度
    const scrollHeight = event.srcElement.scrollHeight;
    // 距离页面底部的高度
    const height = scrollHeight - scrollTop - clientHeight;
    if (height === 0 && !isLoading && dataList.length < count) {
      this.setState(
        {
          page: page + 1,
        },
        () => {
          this.loadCardData();
        }
      );
    }
  };

  _getAsyncConfig = (e) => {
    let i,
      a,
      n = this.props;
    const { limit, page, defaultSort } = this.state;
    let _this = this;
    if ("edit" == n.mode) {
      i = n.url || "/data/report_preview_card_list";
      a = {
        widgetAssistId: n.widgetName,
        widget: n.componentAttr.concat({
          fields: n.fields,
          forms: n.forms,
          filter: _this.getFilterData(n.filter),
          hasHeader: !0,
          cardConfigFields: n.cardConfigFields,
          cardConfig: n.cardConfig,
          bgColorFilter: n.bgColorFilter,
        }),
        appId: n.appId,
        entryId: n.entryId,
        sort: defaultSort ? defaultSort.slice(0) : {},
        skip: page * limit,
        limit: limit,
        rowOrder: n.rowOrder,
        top: n.top,
        hasCount: !!e,
        isCountOnly: !!e,
        popupFormPath: n.popupFormPath,
      };
    } else {
      i = "/data/report_card_list";
      a = {
        widgetId: n.widgetId,
        appId: n.appId,
        entryId: n.entryId,
        fields: n.fields,
        sort: defaultSort ? defaultSort.slice(0) : {},
        skip: page * limit,
        limit: limit,
        popupFormPath: n.popupFormPath,
        filter: _this.getFilterData(n.filter),
        hasCount: !!e,
        isCountOnly: !!e,
      };
    }
    return {
      url: i,
      data: a,
    };
  };

  getFilterData = (t) => {
    let e = this.props,
      i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1),
      a = [];
    let i = i1.filter;
    this.filterMap = i1.filterMap;
    i && (a = a.concat(i));
    BsyUtils.isObjectEmpty(t) || (a = a.concat(t));
    e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond));
    return BsyUtils.isObjectEmpty(a)
      ? {}
      : {
        cond: a,
        rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND,
      };
  };

  reload = () => {
    this.loadData(!0);
  };

  loadWidget = (n, d, s) => {
    this.loadData(n, d, s);
  };

  loadData = (v) => {
    this.setState(
      {
        isLoading: true,
        page: 0,
        dataList: [],
      },
      () => {
        setTimeout(() => {
          this.loadCardData();
        }, 30);
      }
    );
  };

  loadCardData = () => {
    let data = this._getAsyncConfig();
    React.axios(data.url, data.data)
      .then((res) => {
        const { cardConfig } = this.props;
        this.reftype = res.data.reftype;
        let card_image = {};
        let card_top_left = {};
        let card_top_right = {};
        let card_bottom_left = {};
        let card_bottom_right = {};
        let fields = [];
        this._getFiels();

        res.data.header.map((res1, key) => {
          this.fields.map((res2, key) => {
            if (res1.name === res2.name) {
              fields.push(res1);
            }
          });
        });
        this.props.cardConfigFields &&
          this.props.cardConfigFields.map((res1, key) => {
            if (cardConfig) {
              if (cardConfig.has_Image) {
                if (cardConfig.widget_id.has_Image) {
                  if (res1.name === cardConfig.widget_id.has_Image.name) {
                    // card_image = res1;
                    card_image = cardConfig.widget_id.has_Image;
                    card_image.tag = cardConfig.widget_id.has_Image.tag;
                  }
                }
              }
              if (cardConfig.has_create_info_left_top) {
                if (cardConfig.widget_id.has_create_info_left_top) {
                  if (
                    res1.name ===
                    cardConfig.widget_id.has_create_info_left_top.name
                  ) {
                    card_top_left =
                      cardConfig.widget_id.has_create_info_left_top;
                    card_top_left.tag =
                      cardConfig.widget_id.has_create_info_left_top.tag;
                  }
                }
              }
              if (cardConfig.has_create_info_right_top) {
                if (cardConfig.widget_id.has_create_info_right_top) {
                  if (
                    res1.name ===
                    cardConfig.widget_id.has_create_info_right_top.name
                  ) {
                    card_top_right =
                      cardConfig.widget_id.has_create_info_right_top;
                    card_top_right.tag =
                      cardConfig.widget_id.has_create_info_right_top.tag;
                  }
                }
              }
              if (cardConfig.has_create_info_left_down) {
                if (cardConfig.widget_id.has_create_info_left_down) {
                  if (
                    res1.name ===
                    cardConfig.widget_id.has_create_info_left_down.name
                  ) {
                    card_bottom_left =
                      cardConfig.widget_id.has_create_info_left_down;
                    card_bottom_left.tag =
                      cardConfig.widget_id.has_create_info_left_down.tag;
                  }
                }
              }
              if (cardConfig.has_create_info_right_down) {
                if (cardConfig.widget_id.has_create_info_right_down) {
                  if (
                    res1.name ===
                    cardConfig.widget_id.has_create_info_right_down.name
                  ) {
                    card_bottom_right =
                      cardConfig.widget_id.has_create_info_right_down;
                    card_bottom_right.tag =
                      cardConfig.widget_id.has_create_info_right_down.tag;
                  }
                }
              }
            }
          });

        BsyUtils.Store.set(this._getShowFieldKey(), fields);
        this.setState(
          {
            dataList: this.state.dataList.concat(res.data.data),
            headerList: fields,
            isLoading: false,
            count: res.data.count,
            card_image,
            card_top_left,
            card_top_right,
            card_bottom_left,
            card_bottom_right,
          },
          () => {
            // v && this.map.clearMap();
            if (this.props.onLoadSuccess) {
              this.props.onLoadSuccess(res.data);
            }
          }
        );
      })
      .catch((res) => {
        if (this.props.onConfigError) {
          if (res.status) {
            this.props.onConfigError(res.data);
          }
        }
      });
  };

  _createData = (e, i, t, s) => {
    let a = this;

    let n = {
      text: "",
    };

    if (BsyUtils.isObjectEmpty(e)) return "";
    switch (i.type) {
      case "checkboxgroup":
      case "combocheck":
      case "array":
        if (i.colorEnable && !t) {
          let z = BsyUtils.getColorTagList({
            field: i,
            values: e,
            multiLine: !0,
            tagCss: {
              "margin-right": "2px",
            },
            className: "table-tag-list",
          });
          n.html = z.outerHTML;
        } else {
          n.text = BsyUtils.isNull(e) ? "" : e.join(", ");
        }
        break;
      case "radiogroup":
      case "combo":
        if (i.colorEnable && !t) {
          let z = BsyUtils.getColorTagList({
            field: i,
            values: [e],
            multiLine: !0,
            tagCss: {
              "margin-right": "2px",
            },
            className: "table-tag-list",
          });
          n.html = z.outerHTML;
        } else {
          if ("creator" === i.field) {
            n.text = BsyUtils._toDeptUser(e, i.type);
            break;
          } else n.text = e;
        }
        break;
      case "string":
      case "text":
        if ("creator" === i.field) {
          n.text = BsyUtils._toDeptUser(e, i.type);
          break;
        } else n.html = BsyUtils.replaceURL(e);

        n.text = e;
        break;
      case "textarea":
        n.html = `<pre>${BsyUtils.escapeHtmlSpecialChar(e)}</pre>`;
        break;
      case "id":
      case "did":
      case "user":
      case "dept":
        if (t === "card_image") {
          if (e.avatarurl) {
            n.url = e.avatarurl;
          } else {
            const bg = BsyUtils._toDeptUser(e, i.type)
              ? BsyUtils.formatUserThumb(
                BsyUtils._toDeptUser(e, i.type).toString()
              )
              : "";
            n.html = `<div class="table-user-portrait-name color-${bg.color
              }"><span>${bg.name}</span></div><span> ${BsyUtils._toDeptUser(
                e,
                i.type
              )} </span>`;
          }
        } else {
          if (i.type === "user" && i.name === "creator" && s) {
            if (e.avatarurl) {
              n.html = `<img src=${e.avatarurl} /><span> ${BsyUtils._toDeptUser(
                e,
                i.type
              )} </span>`;
            } else {
              const bg = BsyUtils._toDeptUser(e, i.type)
                ? BsyUtils.formatUserThumb(
                  BsyUtils._toDeptUser(e, i.type).toString()
                )
                : "";
              n.html = `<div class="table-user-portrait-name color-${bg.color
                }"><span>${bg.name}</span></div><span> ${BsyUtils._toDeptUser(
                  e,
                  i.type
                )} </span>`;
            }
          } else {
            n.html = `<span> ${BsyUtils._toDeptUser(e, i.type)} </span>`;
          }
        }

        break;
      case "usergroup":
      case "deptgroup":
        let o = [];
        BsyUtils.forEach(e, function (t, e) {
          o.push(BsyUtils._toDeptUser(e, i.type));
        });
        n.text = o.join(",");
        break;
      case "formula":
      case "number":
        // let r = BsyUtils.fixDecimalPrecision(e);
        // n.text = BsyUtils.num2Str(r, i.format)
        let res = BsyUtils.numberFormatValue(e, i);
        const afterSuffixVal = getAfterSuffix(i.afterSuffix)
        if (afterSuffixVal && res.text && !res.text.includes("%")) {
          res.text =  res.text + ' ' + afterSuffixVal;
        } 
        n.text = res.text;
        break;
      case "address":
      case "location":
        let l = [];
        if (e.province) {
          l.push(e.province);
          if (e.city && e.province !== e.city) {
            l.push(e.city);
          }
          if (e.district) {
            l.push(e.district);
          }
        }
        if (e.detail) {
          l.push(e.detail);
        }
        n.text = BsyUtils.transformDataSourceRow(i, e);
        // console.log(BsyUtils.address2Str(e, l.join(""), i.format))
        break;
      case "image":
        if (e.length > 0)
          // n.img = FX.Utils.getfiledownloadURL(e[0],{"mode":0,"width":320,"height":320});
          // n.img = FX.CONFIG.HOST.IMAGE_HOST + "/" + e[0].qnKey + "?imageView2/" + 0 + "/w/" + 320 + "/h/" + 320;
          n.img = BsyUtils.getfiledownloadURL(e[0], {});
        else n.img = "";
        break;
      case "signature":
      case "upload":
        n.img = "";
        break;
      case "datetime":
        n.text = BsyUtils.date2Str(dayjsUtils.timeToTZ(e), i.format);
        break;
      case "linkdata":
        let d = e && e.key;
        if (BsyUtils.isNull(d)) break;
        "datetime" === i.linkType
          ? (n.text = BsyUtils.date2Str(dayjsUtils.timeToTZ(d), "yyyy-MM-dd"))
          : (n.text = d);
        if ("number" === i.linkType) {
          let res = BsyUtils.numberFormatValue(d, i);
          const afterSuffixVal = getAfterSuffix(i.afterSuffix)
          if (afterSuffixVal && res.text && !res.text.includes("%")) {
            res.text =  res.text + ' ' + afterSuffixVal;
          } 
          n.text = res.text;
        }

        break;
      case "flowState":
      case "flowstate":
        let u = window.FX.CONST.WORKFLOW.FLOWSTATE,
          h = {};
        e = parseInt(e);
        h[u.INPROCESS] = React.language("flow.state.inProcess");
        h[u.COMPLETE] = React.language("flow.state.complete");
        h[u.CLOSE] = React.language("flow.state.closed");
        n.text = h[e];
        break;
      case "flowdecision":
        n.text = BsyUtils.getFlowDecisionText(e);
        break;
      case "chargers":
        let p = {},
          f = {};
        BsyUtils.forEach(e, function (t, e) {
          if (e.flowName) {
            if (!p[e.flowName]) {
              p[e.flowName] = !0;
            }
            if (!f[e.userNickname]) {
              f[e.userNickname] = !0;
            }
          }
        });
        let m = [];
        "node" === i.show
          ? BsyUtils.forEach(p, function (t) {
            m.push(t);
          })
          : BsyUtils.forEach(f, function (t) {
            m.push(t);
          });
        n.text = m.join(",");
        break;
      default:
        n.text = e;
    }

    let cont = "";
    n.text = BsyUtils.escapeHtmlSpecialChar(n.text);
    if (n.img) {
      cont = n.img;
    } else if (n.html) {
      cont = n.html;
    } else if (n.text) {
      cont = n.text;
    }

    return cont;
  };

  createMapTableMenu = (res, res1) => {
    const { menu, onRowMenuEvent } = this.props;
    const { dataList, headerList } = this.state;
    let css = {};
    let menuFlag =
      !res.dataPerms || !res.dataPerms.menu || !res.dataPerms.menu[res1.menuId];
    if (menuFlag) {
      css = { color: "#aaa", cursor: "no-drop" };
    } else {
      css = { color: res1.color, cursor: "pointer" };
    }
    return (
      <div className="item" style={css}>
        {res1.mode === "text" ? (
          <span
            data-tip={res1.tip}
            data-place={"bottom"}
            data-type={window.mode}
            data-html={!!res1.tip}
            style={css}
            title={res1.tip}
            onClick={(e) => {
              e.stopPropagation();
              if (!menuFlag) {
                let rowdata = { ...res };
                if (typeof onRowMenuEvent === "function")
                  onRowMenuEvent(res1, rowdata, this.reftype, e);
              }
              // !menuFlag && _menuBatchEvnet(res1.menuId, !1, [res._id], headerList, res, false, res1, true, 'datamenu')
            }}
          >
            {res1.name}
          </span>
        ) : (
          <i
            data-tip={res1.tip}
            data-place={"bottom"}
            data-type={window.mode}
            data-html={!!res1.tip}
            style={css}
            className={"icon-bby-reportmenu-" + res1.icon}
            title={res1.tip}
            onClick={(e) => {
              e.stopPropagation();
              if (!menuFlag) {
                let rowdata = { ...res };
                if (typeof onRowMenuEvent === "function")
                  onRowMenuEvent(res1, rowdata, this.reftype, e);
              }
              // !menuFlag && _menuBatchEvnet(res1.menuId, !1, [res._id], headerList, res, false, res1, true, 'datamenu')
            }}
          ></i>
        )}
      </div>
    );
  };

  create = (res, menu, cb) => {
    let that = this;
    that.popupFormPath = that.popupFormPath || [];
    let _opt = this.props;
    let d1 = {
      formId: _opt.forms[0],
      appId: _opt.appId,
      entryId: _opt.entryId,
      authGroupId: _opt.origin ? null : _opt.authGroupId,
      extDashData: _opt.extDashData,
      popupFormPath: _opt.extDashData
        ? null
        : !_opt.origin
          ? undefined
          : that.popupFormPath.concat({
            appId: _opt.appId,
            entryId: _opt.entryId,
            formId: _opt.forms[0],
            widgetId: _opt.widgetId,
            // menuId: "create",
            // menuType: 'menu',
            menuId: menu.menuId,
            menuType: menu.menuType || "datamenu",
          }),
    };
    d1 = BsyUtils.checkRefApp(d1);
    let formConfig = {};
    if (res) {
      let that = this;
      that.isSubmitData = false;
      const h = res ? res.data.entry : {};

      window.FX.STATIC.appId = h.appId;
      window.FX.STATIC.entryId = h.entryId;
      window.FX.STATIC.INNERLINK = h._id;

      if (!BsyUtils.isObjectEmpty(h.href)) {
        window.FX.STATIC.FORMHREF = h.href;
      } else {
        window.FX.STATIC.FORMHREF = null;
      }

      formConfig = {
        ...h,
        appId: h.appId,
        entryId: h.entryId,
      };
      formConfig.content.width = "80%";
      formConfig.content.name = h.name;
      formConfig.content.designDataId = res.data ? res.data.dataId : "";
      //designDataId: g ? g.dataId : '',
    }
    that.isSubmitData = false;
    let layerRef = null;
    BsyMaskLayer({
      customCls: "fadein-right",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("BsyMaskLayer")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <BsyFormPane
            hasHeader={true}
            width={"80%"}
            {...d1}
            formConfig={formConfig}
            mode={"new"}
            ignoreAuth={_opt.ignoreAuth}
            ignoreOptAuth={_opt.ignoreOptAuth}
            ignoreValidate={_opt.ignoreValidate}
            onClose={(status, data, autoClose) => {
              if (status) {
                if (!cb) that.reload({});
                that.isSubmitData = true;
              }

              cb && cb();
              layerRef && layerRef.close();
            }}
          />
        );
      },
    });
  };

  BBY_reportCreatForm = (g, isreload, eventType, cb, opt) => {
    let that = this;
    that.isSubmitData = false;
    eventType = eventType || "popupform";
    let n = this.props,
      e = this,
      f = window
        .$('<div class="x-window-mask modal light"/>')
        .css({
          "z-index": window.FX.STATIC.zIndex++,
        })
        .appendTo("body");
    window.FX.STATIC.IS_EVENT = g.entry.isEvent === true;
    let hasFooter = true;
    if (g.entry.content.isSubmit !== "no") hasFooter = true;
    else hasFooter = false;

    window.FX.STATIC.APPID = g.entry.appId;
    window.FX.STATIC.ENTRYID = g.entry.entryId;

    let isref = false;
    let _options = this.props;
    let dd = BsyUtils.checkRefApp({
      appId: _options.appId,
      formId: _options.forms[0],
      entryId: _options.entryId,
    });
    let formview = new window.FX.Form(
      window.$.extend(g.entry.content, {
        renderEl: window.$("<div class='x-shadow-content'/>").appendTo(f),
        appId: g.entry.appId,
        entryId: g.entry.entryId,
        enableRowEdit: g.entry.enableRowEdit,
        hasFlow: !g.entry.hasCoop && g.entry.hasFlow,
        designDataId: g ? g.dataId : "",
        hasFlowPrint: g.entry.hasFlowPrint,
        flows: g.entry.flow,
        is_dock_form: g.is_dock_form,
        multiTabs: g.entry.formTabs,
        formTabsStyle: g.entry.formTabsStyle || {},
        isEvent: g.entry.isEvent,
        height: "100%",
        width: 1080,
        submitText: React.language("submit"),
        eventType: eventType,
        hasFooter: hasFooter,
        printText: g.entry.hasFlowPrint ? g.entry.flow.print_text : null,
        // buttonPosition: "middle",
        customCls: "more-btn fui_platform",
        submitUrl: "/data/create",
        title: g.entry.name,
        popupFormPath: e.props.popupFormPath.concat({
          appId: e.props.appId,
          entryId: e.props.entryId,
          formId: e.props.forms[0],
          widgetId: e.props.widgetId,
          menuId: opt.menuId,
          menuType: opt.menuType || "datamenu",
        }),
        onSuccess: function (a, flowAction, needPrint) {
          isref = true;
          if (a.error_code) {
            let title = React.language("form.submit.fail.charger");
            let msg = React.language("form.submit.fail.charger.desc");
            if (
              a.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_COND
            ) {
              title = React.language("form.submit.fail.cond");
              msg = a.error_info; //;
            }
            window.FX.Msg.alert({
              title: title,
              msg: msg,
              type: "warning",
              text4Cancel: null,
              text4Ok: React.language("iSee"),
            });
            return;
          }
          that.isSubmitData = true;
          formview.element.find(".widget-wrapper").empty();
          formview.element.find(".footer").remove();
          if (needPrint) {
            window.FX.Utils._showFormPrint(a.data);
            window.FX.Utils.showSuccessInfo(
              formview.element.find(".widget-wrapper"),
              a,
              function () {
                f.remove();
                e.BBY_reportCreatForm(g, isreload, eventType, cb, opt);
              }
            );
          } else {
            if (a.submitPrompt.popupAutoClose) {
              window.FX.STATIC.APPID = n.appId;
              window.FX.STATIC.ENTRYID = n.entryId;
              f.remove();
              if (isreload) {
                that.reload({});
              }
              cb && cb();
              return;
            }
            window.FX.Utils.showSuccessInfo(
              formview.element.find(".widget-wrapper"),
              a,
              function () {
                f.remove();
                e.BBY_reportCreatForm(g, isreload, eventType, cb, opt);
              }
            );
          }

          // needPrint && BsyUtils._showFormPrint(a.data)
        },
        onError: function (a) {
          formview.element.find(".widget-wrapper").empty();
          formview.element.find(".footer").remove();
          window.FX.Utils.showErrorInfo(
            formview.element.find(".widget-wrapper"),
            a,
            function () {
              f.remove();
              e.BBY_reportCreatForm(g, isreload, eventType, cb, opt);
            }
          );
        },
        onAfterCancel: function () {
          f.remove();
          if (eventType == "new") {
            that.loadData(!0);
          } else if (cb) {
            cb();
          }
          window.FX.STATIC.APPID = n.appId;
          window.FX.STATIC.ENTRYID = n.entryId;
        },
      })
    );
  };

  BBY_doSort = () => {
    let e = this;
    let i = null;
    let a = new window.FX.ConfirmDialog({
      title: React.language("dash.sort.setting"),
      width: 600,
      text4Ok: React.language("sort"),
      hasSeparator: !0,
      onContentCreate: function (t) {
        i = t;
      },
      onOk: function () {
        e.setState(
          {
            defaultSort: n.getSorts(),
          },
          () => {
            e.loadData(!0);
          }
        );
        a.close();
      },
    });
    a.show();
    let n = new window.FX.DashSortPane({
      renderEl: i,
      fields: this.state.fields,
      sorts: this.state.defaultSort,
    });
  };

  _doShowData = (e, type, noSwitchBtn, animation, lowLayer) => {
    const FX = window.FX;
    const $ = window.$;
    let i = this.getDataByIdx(e) || {};
    this._dataIndex = e;
    let that = this;
    let layerRef = null;
    let extDashData = {
      appId: this.props.appId,
      entryId: this.props.entryId,
      formId: this.props.forms[0],
      widgetId: this.props.widgetId,
    };

    if (i) {
      let a = this,
        n = this.props,
        s = i._id,
        o = this.state.headerList;
      let r = $('<div class="x-window-mask modal light"/>').css({
        "z-index": FX.STATIC.zIndex++,
      });
      let f = i._id;
      let b = e;
      let hasCopy = i.dataPerms ? i.dataPerms.copy : false;
      let hasEditBtn = i.dataPerms ? i.dataPerms.update : n.itemEditable,
        hasDeleteBtn = i.dataPerms ? i.dataPerms.delete : n.itemRemovable,
        hasLog = i.dataPerms ? i.dataPerms.log : n.itemLog,
        hasComment = i.dataPerms ? i.dataPerms.comment : n.itemComment,
        flow_log = i.dataPerms ? i.dataPerms.flow_log : n.flow_log;

      if (a.reftype == "etl_table" || a.reftype == "aggregate_table") {
        let config = {
          appId: n.appId,
          formId: n.forms[0],
          entryId: n.entryId,
          origin: "report",
          originPrint: "report",
          ptlist: [],
          widgetId: n.widgetName,
          hasFlowLog: flow_log,
          hasLogView: flow_log,
          hasFlowBtn: flow_log,
          hasShareBtn: !1,
          sourceType: n.type,
          width: 1080,
          forms: n.forms,
          header: a._parseFieldLabelFormat(n.fields),
          data: i,
          optAuth: i.optAuth,
          multiTabs: null,
          dataId: i._id,
          title: n.title,
          height: "100%",
          // hasShareBtn: !1,
          dataIndex: e + 1,
          hasSwitchBtn: !noSwitchBtn,
          hasPrintBtn: !0,
          hasCustomPrint: !0,
          dataCount: a.state.dataList.length,
          hasEditBtn: hasEditBtn,
          hasDeleteBtn: hasDeleteBtn,
          dataPerms: i.dataPerms,
          hasLog: n.isEtlTable ? false : hasLog,
          hasComment: n.isEtlTable ? false : hasComment,
          onSwitchData: function (a, b) {
            let c = that.getDataByIdx(a - 1);
            return c;
          },
        };

        BsyMaskLayer({
          customCls: animation ? "fadein-right" : "",
          onMaskClick: (event) => {
            // if (event.target.classList.contains("BsyMaskLayer")) {
            //   layerRef.close();
            // }
          },
          onContentCreate: (ref) => {
            layerRef = ref;

            return (
              <BsyFormPane
                {...config}
                mode={"view"}
                entrance={"report"}
                onClose={(status) => {
                  layerRef && layerRef.close();
                }}
              />
            );
          },
        });
        lowLayer && lowLayer.close();
        return;
      }

      // if (n.popupFormPath[0]) {
      //     n.popupFormPath[0].menuType = "datamenu";
      // }

      let d1 = BsyUtils.checkRefApp({
        appId: n.appId,
        entryId: n.entryId,
        formId: n.forms[0],
        dataId: f,
        iseditable: !1,
        fields: n.fields,
        formulas: n.formulas,
        popupFormPath: n.popupFormPath.concat({
          appId: n.appId,
          entryId: n.entryId,
          formId: n.forms[0],
          widgetId: n.widgetId,
        }),
      });
      const { restore } = BsyUtils.globalIdManager(d1.appId, d1.entryId);
      if (this.props.widgetId) {
        d1 = { ...d1, widgetId: this.props.widgetId };
      }
      FX.Utils.dataAjax(
        {
          url: "/data/read",
          data: d1,
        },
        function (g) {
          let fieldtabs = {};
          FX.Utils.forEach(g.form.items, function (a1, b1) {
            if (b1.tab) fieldtabs[b1.widget.widgetName] = b1.tab;
          });
          let newdata = {};
          let fields = [];
          let o1 = a._parseFieldLabelFormat(n.fields, g.form.items);
          FX.Utils.forEach(o1, function (a1, b1) {
            let tmpdata = $.extend({}, b1);

            if (["dataload", "button"].indexOf(b1.type) > -1) {
              return !0;
            }

            if (fieldtabs.hasOwnProperty(b1.name)) {
              tmpdata.tab = fieldtabs[b1.name];
            }
            fields.push(tmpdata);
            newdata[b1.tag] = g.data[b1.name];
          });
          newdata["_id"] = g.data["_id"];
          if (g.hasCoop || !g.hasFlow) {
            flow_log = !1;
          }
          if (flow_log) {
            newdata["flowStack"] = g.data["flowStack"];
            newdata["flowState"] = g.data["flowState"];
            newdata["chargers"] = g.data["chargers"];
            newdata["flowVer"] = g.data["flowVer"];
          }
          newdata = $.extend(newdata, g.data);
          newdata.optAuth = i.optAuth;
          let config = {
            appId: d1.appId,
            formId: d1.formId,
            entryId: d1.entryId,
            refAppId: d1.refAppId,
            form: g.form,
            origin: "report",
            originPrint: "report",
            widgetId: n.widgetName || a.props.widgetId,
            items: g.form.items,
            sourceType: n.type,
            rawdata: a.props.rawdata,
            extDashData: a.props.rawdata ? extDashData : null,
            fieldShowRules: g.form.fieldShowRules,
            is_dock_form: g.is_dock_form,
            subformFieldShowRules: g.form.subformFieldShowRules,
            ptlist: n.isEtlTable ? [] : i.dataPerms && i.dataPerms.ptlist,
            hasFlowLog: flow_log,
            hasLogView: flow_log,
            hasFlowBtn: flow_log,
            hasCopy: hasCopy,
            hasShareBtn: !1,
            width: 1080,
            forms: n.forms,
            header: fields,
            allShowFields: o1,
            data: newdata,
            multiTabs: g.formTabs,
            formTabsStyle: g.formTabsStyle || {},
            dataId: g.data._id,
            optAuth: i.optAuth,
            title: n.title,
            height: "100%",
            // hasShareBtn: !1,
            dataIndex: e + 1,
            hasSwitchBtn: !noSwitchBtn,
            hasPrintBtn: !0,
            hasCustomPrint: !0,
            dataPerms: i.dataPerms,
            dataCount: a.state.dataList.length,
            hasEditBtn: hasEditBtn,
            hasDeleteBtn: hasDeleteBtn,
            hasLog: n.isEtlTable ? false : hasLog,
            hasComment: n.isEtlTable ? false : hasComment,
            popupFormPath: n.popupFormPath.concat({
              appId: n.appId,
              entryId: n.entryId,
              formId: n.forms[0],
              widgetId: n.widgetId,
            }),
            onSwitchData: function (a, b) {
              let c = that.getDataByIdx(a - 1);
              return c;
            },
            onDeleteData: function () {
              BsyAlert({
                title: React.language("del.data.tip"),
                type: "error",
                text4Ok: React.language("ok"),
                text4Cancel: React.language("cancel"),
                OkType: "red",
                ok: function () {
                  that.doDeleteData(f, type);
                  restore();
                  layerRef && layerRef.close();
                },
              });
            },
          };

          BsyMaskLayer({
            customCls: animation ? "fadein-right" : "",
            onMaskClick: (event) => {
              // if (event.target.classList.contains("BsyMaskLayer")) {
              //   layerRef.close();
              // }
            },
            onContentCreate: (ref) => {
              layerRef = ref;
              return (
                <BsyFormPane
                  {...config}
                  mode={"view"}
                  entrance={"report"}
                  onClose={(status) => {
                    restore();
                    layerRef && layerRef.close();
                    if (status) {
                      that.loadData();
                    }
                  }}
                />
              );
            },
          });
        },
        function () {
          restore();
          // layerRef && layerRef.close();
          return !1;
        },
        function () {
          restore();
          // layerRef && layerRef.close();
        }
      );
    }
  };

  doDeleteData = (a, cb) => {
    let b = this.props,
      c = this;
    const FX = window.FX;
    const $ = window.$;
    let _this = this;
    let d = {
      appId: b.appId,
      entryId: b.entryId,
      formId: b.forms[0],
      idList: a,
      popupFormPath: b.popupFormPath.concat({
        appId: b.appId,
        entryId: b.entryId,
        formId: b.forms[0],
        widgetId: b.widgetId,
        menuType: b.menuType || "datamenu",
      }),
    };
    if (FX.Utils.isObjectEmpty(a)) {
      tipAlert({
        type: "warning",
        msg: React.language("no.data.selected"),
      });
      return;
    }

    d = BsyUtils.checkRefApp(d);
    FX.Utils.dataAjax(
      {
        url: "/data/remove",
        data: d,
      },
      function (data) {
        if (data.msg) {
          //给后端_form事件用  返回真的时候有提示信息也要提示 zhxj 19521
          tipAlert({
            type: "success",
            msg: data.msg,
          });
        }
        c.reload();
      }
    );
  };

  _parseFieldLabelFormat = (e, orgds) => {
    function findField(name) {
      var tag = {};
      BsyUtils.forEach(orgds, (index, data) => {
        if (data.widget.widgetName == name) {
          tag = { ...data.widget };
        }
      });
      return tag;
    }

    function colorItemsField(name) {
      var tag = {};
      BsyUtils.forEach(orgds, (index, data) => {
        if (data.widget.widgetName == name) {
          tag = { ...data.widget };
        }
      });
      return tag;
    }

    var i = [];
    BsyUtils.forEach(e, (e, a1) => {
      var n = {};
      if (!orgds) {
        n = { ...a1 };
      } else {
        if (a1.type == "linkquery") {
          n = { ...a1, ...findField(a1.name) };
        } else if (
          a1.type == "radiogroup" ||
          a1.type == "checkboxgroup" ||
          a1.type == "combo" ||
          a1.type == "combocheck"
        ) {
          n = { ...a1, ...colorItemsField(a1.name) };
        } else {
          n = { ...a1 };
        }
      }
      if (
        (BsyUtils.isNull(n.text) && (n.text = a1.title), "subform" === a1.type)
      ) {
        var s = [];
        BsyUtils.forEach(a1.items, function (e, i) {
          var a = { ...i };
          BsyUtils.isNull(a.text) && (a.text = i.title);
          s.push(a);
        });
        n.items = s;
      }
      i.push(n);
    });
    return i;
  };

  _doEditData = (b, c, type, r) => {
    const FX = window.FX;
    const $ = window.$;
    if (b) {
      r.find(".widget-wrapper").length && r.find(".widget-wrapper").hide();
      r.find(".log-wrapper").length && r.find(".log-wrapper").hide();
      let d = this.props,
        e = this,
        f = $('<div class="x-window-mask"/>')
          .css({
            "z-index": FX.STATIC.zIndex++,
          })
          .appendTo("body");

      let t11 = FX.Utils.createLoadLayer("body", {
        isLight: !1,
        hasLoader: !0,
      });

      let i = this.getDataByIdx(this._dataIndex);
      let n = d;

      let hasEditBtn = i.dataPerms ? i.dataPerms.update : n.itemEditable,
        hasDeleteBtn = i.dataPerms ? i.dataPerms.delete : n.itemRemovable,
        hasLog = i.dataPerms ? i.dataPerms.log : n.itemLog,
        hasComment = i.dataPerms ? i.dataPerms.comment : n.itemComment,
        flow_log = i.dataPerms ? i.dataPerms.flow_log : n.flow_log;

      let d1 = BsyUtils.checkRefApp({
        appId: d.appId,
        entryId: d.entryId,
        formId: d.forms[0],
        dataId: b,
      });
      d1.popupFormPath = n.popupFormPath.concat({
        appId: n.appId,
        entryId: n.entryId,
        formId: n.forms[0],
        widgetId: n.widgetId,
      });
      if (this.props.widgetId) {
        d1 = { ...d1, widgetId: this.props.widgetId };
      }
      FX.Utils.dataAjax(
        {
          url: "/data/read",
          data: d1,
        },
        function (g) {
          FX.STATIC.IS_EVENT = g.isEvent === true;
          if (d.hasOwnProperty("type")) {
            //2022 12 17 查询原始数据改动 直接走后端权限，前端不需要重装判断了
            d.optAuth = { ...i.optAuth };

            // //报表 可编辑权限根据报表设计走
            // FX.Utils.forEach(d.fields, function (index, field) {
            //     d.optAuth = d.optAuth || [];
            //     d.optAuth[field.name] = {
            //         enable: field.hasOwnProperty('isEditable') ? field.isEditable : true, visible: true
            //     };
            //     if (field.type == 'subform') {
            //         $.extend(d.optAuth[field.name], {
            //             subform_create: field.hasOwnProperty('subform_create') ? field.subform_create : true,
            //             subform_delete: field.hasOwnProperty('subform_delete') ? field.subform_delete : true,
            //             subform_edit: field.hasOwnProperty('subform_edit') ? field.subform_edit : true,
            //             subform_import: field.hasOwnProperty('subform_import') ? field.subform_import : true,
            //             subform_dataload: field.hasOwnProperty('subform_dataload') ? field.subform_dataload : true
            //         });
            //         FX.Utils.forEach(field.items, function (ind, subfield) {
            //             d.optAuth[[field.name, subfield.name].join(".")] = {
            //                 enable: subfield.hasOwnProperty('isEditable') ? subfield.isEditable : true, visible: true
            //             }
            //         })
            //     }
            // });
            //有权限组值才会走 判断
            d.authGroupId = 0;
          }
          let optAuth = $.extend({}, d.optAuth);

          if (g.hasOwnProperty("optAuth")) {
            optAuth = $.extend({}, optAuth, g.optAuth);
          }

          if (g.hasCoop || !g.hasFlow) {
            flow_log = !1;
          }

          new FX.Form(
            $.extend(g.form, {
              renderEl: $("<div class='x-shadow-content'/>").appendTo(
                f.addClass(" modal light")
              ),
              appId: d1.appId,
              entryId: d1.entryId,
              formId: d1.formId,
              dataId: b,
              multiTabs: g.formTabs,
              formTabsStyle: g.formTabsStyle || {},
              tabs: g.tabs,
              customCls: "more-btn",
              submitUrl: "/data/update",
              submitData: {
                dataId: b,
              },
              title: g.formName,
              height: "100%",
              width: 1080,
              is_dock_form: g.is_dock_form,
              hasFlow: !g.hasCoop && g.hasFlow,
              hasLogView: !g.hasCoop && g.hasFlow && g.hasLogView,
              hasLog: hasLog,
              hasFlowLog: flow_log,
              hasComment: hasComment,
              submitText: React.language("modify"),
              cancelText: React.language("cancel"),
              ignoreOptAuth: d.ignoreOptAuth,
              ignoreValidate: d.ignoreValidate,
              widgetOptAuth: optAuth, // d.optAuth || g.optAuth,
              authGroupId: 0,
              editValue: g.data,
              mode: "edit",
              // buttonPosition: "middle",
              popupFormPath: n.popupFormPath.concat({
                appId: n.appId,
                entryId: n.entryId,
                formId: n.forms[0],
                widgetId: n.widgetId,
              }),
              onSuccess: function (a) {
                f.remove();
                r && r.remove();
                let dataList = e.state.dataList;
                let headerList = e.state.headerList;
                for (let i = 0; i < headerList.length; i++) {
                  if (a.data[headerList[i].name]) {
                    dataList[c][headerList[i].tag] = a.data[headerList[i].name];
                  }
                }
                e.setState({
                  dataList,
                });
              },
              onAfterCancel: function () {
                f.remove();
                r && r.remove();
              },
            })
          );
        },
        function () {
          r && r.remove();
          t11 && t11.remove();
          return !1;
        },
        function () {
          r && r.remove();
          t11 && t11.remove();
        }
      );
    }
  };

  _getShowFieldKey = () => {
    const { appId, entryId, widgetId } = this.props;
    return BsyUtils.Store.getKey("dashboardShowFields", {
      appId: appId,
      entryId: entryId,
      widgetId: widgetId,
    });
  };

  _updateCachedFields = () => {
    BsyUtils.Store.set(this._getShowFieldKey(), this.fields);

    if (this.props.onReload) {
      this.props.onReload();
    }
    // this.loadData()
  };

  _getFiels = () => {
    let CachedFields =
      this.props.forms.length && this.props.forms[0]
        ? this._getCachedFields()
        : undefined;

    this.allFields = [];
    let CachedFieldsNull = [];
    this.props.fields.map((data, index) => {
      if (!data.detailOnly) {
        this.allFields.push(data);
      }
      if (data.name !== "label" && !data.detailOnly) {
        CachedFieldsNull.push(data);
      }
    });
    this.fields = CachedFields === undefined ? this.allFields : CachedFields;
  };

  _getCachedFields = () => {
    return BsyUtils.Store.get(this._getShowFieldKey());
  };

  BBY_doSetFields = (t) => {
    let e = this;
    if (!BsyUtils.isNull(e.fields)) {
      let i = BsyUtils.getShowFieldItems(e.fields, this.allFields);
      let value = [];
      BsyUtils.forEach(i, (index, data) => {
        if (data.selected) {
          value.push(data.value);
        }
      });
      BsyMsgBubble({
        anchor: t.target,
        contentHTML: (ref) => {
          return (
            <TriggerComboCheckPane
              items={i}
              hasSelectAll={true}
              value={value}
              onSelect={(val) => {
                // that.selectItem(val)
                e.fields = BsyUtils.getShowFieldsByNames(e.allFields, val);
              }}
              onSeach={this.onSeach}
            />
          );
        },
        text4Cancel: null,
        text4Ok: null,
        theme: this.props.theme,
        minWidth: 150,
        width: 230,
        contentPadding: 0,
        edge: 200,
        hAdjust: 72,
        dockPosition: "left",
        onClose: function () {
          e._updateCachedFields();
          return !1;
        },
      });
    }
  };

  getDataByIdx = (t) => {
    const { dataList } = this.state;
    return dataList[t];
  };

  _isCondItemMatch = (t, e) => {
    const FX = window.FX;
    this.widgetFilterMap = {
      text: TextWidgetFilter,
      number: NumberWidgetFilter,
      formula: NumberWidgetFilter,
      datetime: DatetimeWidgetFilter,
      combocheck: ComboCheckWidgetFilter,
      textarea: TextareaWidgetFilter,
      address: AddressWidgetFilter,
      user: UserWidgetFilter,
      usergroup: UserGroupWidgetFilter,
      dept: DeptWidgetFilter,
      deptgroup: DeptGroupWidgetFilter,
      signature: SignatureWidgetFilter,
      file_list: FileListWidgetFilter,
      flowState: NumberWidgetFilter,
      flowstate: NumberWidgetFilter,
      flowDecision: NumberWidgetFilter,
      flowdecision: NumberWidgetFilter,
      chargers: UserGroupWidgetFilter,
      radiogroup: TextWidgetFilter,
      checkboxgroup: ComboCheckWidgetFilter,
      combo: TextWidgetFilter,
      image: FileListWidgetFilter,
      upload: FileListWidgetFilter,
    };
    var i = this.widgetFilterMap[t.type];
    return !!i && new i(t).invoke()(e);
  };

  _check_data_bkcolor = (data, bkColor, bkColorKey, bkColorType) => {
    let b = this;
    let i = b.props;
    let res = "";

    if (
      i.bgColorFilter &&
      i.bgColorFilter.length > 0 &&
      i.bgColorFilter[0].options
    ) {
      bkColor = i.bgColorFilter[0].options;
      bkColorKey = i.bgColorFilter[0].tag;
      bkColorType = i.bgColorFilter[0].type;
    }
    if (data[bkColorKey] === undefined) {
      if (this.bkColor && this.bkColor.length && i.bgColorFilter) {
        BsyUtils.forEach(this.bkColor, function (index, val) {
          let method = val.method;
          let t = {
            field: i.bgColorFilter[0].tag,
            id: i.bgColorFilter[0].id || i.bgColorFilter[0].form,
            method: method == "formula" ? "eq" : method,
            name: i.bgColorFilter[0].name,
            type: bkColorType,
            value: val.term,
          };
          let hasDataColor = b._isCondItemMatch(t, null);
          if (hasDataColor) {
            res = [val.color, val.colorText];
          }
        });
      }
      return res;
    }
    if (bkColor && bkColor.length) {
      //检查数据条件并设置对应的颜色
      BsyUtils.forEach(bkColor, function (index, val) {
        let dataItem;
        let value;
        let method = val.method;
        if (val.fixed === "currentUser") {
          value = window.FX.STATIC.user.dock_userid
            ? [window.FX.STATIC.user.dock_userid]
            : [window.FX.STATIC.user._id];
        } else {
          if (
            bkColorType === "flowState" ||
            bkColorType === "flowstate" ||
            bkColorType === "flowDecision" ||
            bkColorType === "flowdecision"
          ) {
            value = [val.fixed];
          } else if (
            bkColorType === "image" ||
            bkColorType === "upload" ||
            bkColorType === "signature"
          ) {
            if (val.fixed.indexOf("NotNull") > -1) {
              method = "not_empty";
            } else {
              method = "empty";
            }
          } else if (bkColorType === "number" || bkColorType === "formula") {
            value = BsyUtils.isArray(val.term[0]) ? val.term[0] : val.term;
            let newVal = [];
            BsyUtils.forEach(value, function (obj, val) {
              newVal.push(isNaN(Number(val)) ? null : Number(val));
            });
            value = newVal;
          } else if (bkColorType === "datetime") {
            value = BsyUtils.isArray(val.term[0]) ? val.term[0] : val.term;
            if (val.method == "range") {
              let newVal = [];
              BsyUtils.forEach(val.term, function (obj, val) {
                newVal.push(BsyUtils.date2Str(dayjsUtils.timeToTZ(val), "yyyy-MM-dd"));
              });
              value = newVal;
            } else {
              if (val.fixed !== "fixed") {
                value = [val.fixed];
              } else {
                let newVal = [];
                BsyUtils.forEach(value, function (obj, val) {
                  newVal.push(BsyUtils.date2Str(dayjsUtils.timeToTZ(val), "yyyy-MM-dd"));
                });
                value = newVal;
              }
            }
          } else {
            value = BsyUtils.isArray(val.term[0]) ? val.term[0] : val.term;
          }
        }
        let t = {
          field: i.bgColorFilter[0].tag,
          id: i.bgColorFilter[0].id || i.bgColorFilter[0].form,
          method: method == "formula" ? "eq" : method,
          name: i.bgColorFilter[0].name,
          type: bkColorType,
          value: value,
        };
        if (
          (val.fixed === "currentUser" ||
            (i.bgColorFilter.length && i.bgColorFilter[0].name === "creator") ||
            bkColorType === "user") &&
          bkColorType !== "chargers"
        ) {
          dataItem =
            data[bkColorKey] && data[bkColorKey].id ? data[bkColorKey].id : "";
        } else if (bkColorType === "usergroup") {
          let usergroup = [];
          BsyUtils.forEach(data[bkColorKey], function (obj, val) {
            usergroup.push(
              val.id ? val.id : BsyUtils.isArray(val) ? val : val.id
            );
          });
          dataItem = usergroup;
        } else if (bkColorType === "chargers") {
          let usergroup = [];
          BsyUtils.forEach(data[bkColorKey], function (obj, val) {
            usergroup.push(
              val.userId
                ? val.userId.indexOf("@") >= 0
                  ? val.userId.split("@")[0]
                  : val.userId
                : !BsyUtils.isArray(val)
                  ? val.userId.indexOf("@") >= 0
                    ? val.userId.split("@")[0]
                    : val.userId
                  : val
            );
          });
          dataItem = usergroup;
        } else if (
          bkColorType === "flowdecision" ||
          bkColorType === "flowDecision"
        ) {
          dataItem =
            data[bkColorKey] === undefined
              ? null
              : Number(data[bkColorKey].state_id);
        } else if (bkColorType === "number" || bkColorType === "formula") {
          dataItem = isNaN(Number(data[bkColorKey]))
            ? null
            : Number(data[bkColorKey]);
        } else if (bkColorType === "datetime") {
          dataItem = data[bkColorKey] === undefined ? null : data[bkColorKey];
          dataItem = BsyUtils.date2Str(dayjsUtils.timeToTZ(dataItem), "yyyy-MM-dd");
        } else {
          dataItem = data[bkColorKey] === undefined ? null : data[bkColorKey];
        }
        let hasDataColor = b._isCondItemMatch(t, dataItem);
        if (hasDataColor) {
          res = [val.color, val.colorText];
        }
      });
    }
    return res;
  };

  render() {
    const {
      isLoading,
      dataList,
      headerList,
      card_image,
      card_top_left,
      card_top_right,
      card_bottom_left,
      card_bottom_right,
    } = this.state;
    const { cardConfig, menu } = this.props;
    let col;
    let size;
    let way;
    let pos;
    let hasFieldTitle;
    if (cardConfig) {
      col = cardConfig.col ? cardConfig.col : "line1";
      size = cardConfig.size ? cardConfig.size : "middle";
      way = cardConfig.has_Image
        ? cardConfig.widget_id.has_Image
          ? cardConfig.widget_id.has_Image.wayValue
            ? cardConfig.widget_id.has_Image.wayValue
            : "top"
          : ""
        : "";
      pos = cardConfig.has_Image
        ? cardConfig.widget_id.has_Image
          ? cardConfig.widget_id.has_Image.posValue
            ? cardConfig.widget_id.has_Image.posValue
            : "fill"
          : ""
        : "";
      hasFieldTitle = cardConfig.has_field_label;
      if (size === "small") {
        col = "line1";
      } else if (size === "middle") {
        if (cardConfig.has_Image) {
          if (cardConfig.widget_id.has_Image) {
            if (cardConfig.widget_id.has_Image.posValue !== "top") {
              col = "line1";
            }
          }
        }
      }
    } else {
      col = "line1";
      size = "middle";
      way = "top";
      pos = "fill";
      hasFieldTitle = true;
    }

    const place = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    return (
      <div className="BsyDashCard" ref={this.cardCont}>
        {isLoading ? <BsySLoading mode={"skeletonspin"} /> : ""}
        <div className="bsy-card-content">
          {dataList.length > 0 &&
            dataList.map((res, key) => {
              let image_url = "";
              let top_left = "";
              let top_right = "";
              let bottom_left = "";
              let bottom_right = "";
              if (!res) {
                return;
              }
              if (card_image.tag) {
                image_url = this._createData(
                  res[card_image.tag],
                  card_image,
                  "card_image",
                  true
                );
              }
              if (card_top_left.tag) {
                top_left = this._createData(
                  res[card_top_left.tag],
                  card_top_left,
                  "header"
                );
              }
              if (card_top_right.tag) {
                top_right = this._createData(
                  res[card_top_right.tag],
                  card_top_right,
                  "header"
                );
              }
              if (card_bottom_left.tag) {
                bottom_left = this._createData(
                  res[card_bottom_left.tag],
                  card_bottom_left,
                  "header",
                  size === "large" ||
                  way === "top" ||
                  !cardConfig.has_create_info_right_down
                );
              }
              if (card_bottom_right.tag) {
                bottom_right = this._createData(
                  res[card_bottom_right.tag],
                  card_bottom_right,
                  "header"
                );
              }
              let hasIcon = !(!hasFieldTitle && col === "line2");
              let color = this._check_data_bkcolor(res);
              let ing = {};
              if (!BsyUtils.isObjectEmpty(color)) {
                ing = {
                  background: "rgb(" + color[0] + ")",
                  color: "rgb(" + color[1] + ")",
                  // border: "1px solid rgb(" + _this.dataMap.background[0] + ")",
                };
              }
              let bg = {};
              if (res && res[card_image.tag] && card_image.type === "user") {
                if (
                  res &&
                  res[card_image.tag] &&
                  res[card_image.tag].avatarurl
                ) {
                  image_url = res[card_image.tag]
                    ? res[card_image.tag].avatarurl
                    : "";
                } else {
                  bg = BsyUtils.formatUserThumb(
                    BsyUtils._toDeptUser(res[card_image.tag], card_image.type)
                  );
                }
              }
              return (
                <div
                  className={`card card-${key} ${size} ${col} ${way} ${pos} ${menu && menu.enable && menu.set.length > 0 ? "hasMenu" : ""
                    }`}
                >
                  {cardConfig.has_Image && cardConfig.widget_id.has_Image && (
                    <div className="card-title">
                      <div className="image">
                        {card_image.type !== "user" && !image_url && (
                          <img
                            className="card_image_empty"
                            src={
                              window.rootDirectroy +
                              "/template/formreport/static/css/resources/images/card_image_empty@2x.png"
                            }
                            alt=""
                          />
                        )}
                        {card_image.type === "user" && !image_url ? (
                          <div className={"nickname color-" + bg.color}>
                            {bg.name}
                          </div>
                        ) : (
                          <div
                            className="img-header"
                            style={{ backgroundImage: `url(${image_url})` }}
                          ></div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="card-content">
                    {!(
                      !cardConfig.has_create_info_left_top &&
                      !cardConfig.has_create_info_right_top &&
                      !cardConfig.has_create_info_left_down &&
                      !cardConfig.has_create_info_right_down
                    ) && (
                        <div className="card-header">
                          <div className="top">
                            {cardConfig.has_create_info_left_top && (
                              <div
                                className="left"
                                title={BsyUtils.transformDataSourceRow(
                                  card_top_left,
                                  res[card_top_left.tag]
                                )}
                                style={{
                                  width: cardConfig.has_create_info_right_top
                                    ? ""
                                    : "100%",
                                }}
                                dangerouslySetInnerHTML={{ __html: top_left }}
                              ></div>
                            )}
                            {top_right ? (
                              <div
                                className="right"
                                title={BsyUtils.transformDataSourceRow(
                                  card_top_right,
                                  res[card_top_right.tag]
                                )}
                                style={{
                                  width: cardConfig.has_create_info_left_top
                                    ? ""
                                    : "100%",
                                  maxWidth: cardConfig.has_create_info_left_top
                                    ? ""
                                    : "100%",
                                  ...ing,
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: cardConfig.has_create_info_right_top
                                    ? top_right
                                    : "",
                                }}
                              ></div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div
                            className="bottom"
                            style={{
                              height:
                                !cardConfig.has_create_info_left_down &&
                                  !cardConfig.has_create_info_right_down
                                  ? "0"
                                  : "",
                            }}
                          >
                            {cardConfig.has_create_info_left_down && (
                              <div
                                className="left"
                                title={BsyUtils.transformDataSourceRow(
                                  card_bottom_left,
                                  res[card_bottom_left.tag]
                                )}
                                style={{
                                  width: cardConfig.has_create_info_right_down
                                    ? ""
                                    : "100%",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    card_bottom_left.type === "user" &&
                                      card_bottom_left.name === "creator" &&
                                      (size === "large" || way === "top")
                                      ? bottom_left
                                      : `<span>${bottom_left}</span>`,
                                }}
                              ></div>
                            )}
                            {cardConfig.has_create_info_right_down && (
                              <div
                                className="right"
                                title={BsyUtils.transformDataSourceRow(
                                  card_bottom_right,
                                  res[card_bottom_right.tag]
                                )}
                                style={{
                                  width: cardConfig.has_create_info_left_down
                                    ? ""
                                    : "100%",
                                }}
                                dangerouslySetInnerHTML={{ __html: bottom_right }}
                              ></div>
                            )}
                          </div>
                        </div>
                      )}
                    <div
                      className="card-body"
                      onClick={() => {
                        this._doShowData(key, "newMap");
                      }}
                    >
                      {headerList.length > 0 &&
                        headerList.map((res1) => {
                          let u = [];
                          let p = [];
                          if (res1.type === "chargers") {
                            res[res1.tag] &&
                              res[res1.tag].map((res2) => {
                                if (
                                  res2.flowName &&
                                  u.indexOf(res2.flowName) < 0
                                ) {
                                  u.push(res2.flowName);
                                }
                                if (
                                  res2.userNickname &&
                                  p.indexOf(res2.userNickname) < 0
                                ) {
                                  p.push(res2.userNickname);
                                }
                              });
                          }
                          return (
                            !res1.detailOnly &&
                            res1.type !== "menu" && (
                              <>
                                {res1.type === "chargers" ? (
                                  <>
                                    {
                                      <div className="dataItem">
                                        {hasIcon && (
                                          <div className="dataIcon">
                                            <i className="icon-curForm"></i>
                                          </div>
                                        )}
                                        {hasFieldTitle && (
                                          <div
                                            title={React.language(
                                              "flow.node.current"
                                            )}
                                            className="dataTitle"
                                          >
                                            {React.language(
                                              "flow.node.current"
                                            )}
                                          </div>
                                        )}
                                        <div
                                          title={u.join("、")}
                                          className={`dataContent ${hasFieldTitle ? "" : " empty"
                                            } ${"card-" + res1.type}`}
                                        >
                                          {u.join("、")}
                                        </div>
                                      </div>
                                    }
                                    {
                                      <div className="dataItem">
                                        {hasIcon && (
                                          <div className="dataIcon">
                                            <i
                                              className={BsyUtils._getFieldTypeIcon(
                                                res1.type
                                              )}
                                            ></i>
                                          </div>
                                        )}
                                        {hasFieldTitle && (
                                          <div
                                            title={React.language(
                                              "flow.charger.current"
                                            )}
                                            className="dataTitle"
                                          >
                                            {React.language(
                                              "flow.charger.current"
                                            )}
                                          </div>
                                        )}
                                        <div
                                          title={p.join("、")}
                                          className={`dataContent ${hasFieldTitle ? "" : " empty"
                                            } ${"card-" + res1.type}`}
                                        >
                                          {p.join("、")}
                                        </div>
                                      </div>
                                    }
                                  </>
                                ) : (
                                  <div className="dataItem">
                                    {hasIcon && (
                                      <div className="dataIcon">
                                        <i
                                          className={BsyUtils._getFieldTypeIcon(
                                            res1.type
                                          )}
                                        ></i>
                                      </div>
                                    )}
                                    {hasFieldTitle && (
                                      <div
                                        title={res1.title}
                                        className="dataTitle"
                                      >
                                        {res1.title}
                                      </div>
                                    )}
                                    <div
                                      title={BsyUtils.transformDataSourceRow(
                                        res1,
                                        res[res1.tag]
                                      )}
                                      className={`dataContent ${hasFieldTitle ? "" : " empty"
                                        } ${"card-" + res1.type}`}
                                      dangerouslySetInnerHTML={{
                                        __html: this._createData(
                                          res[res1.tag],
                                          res1
                                        ),
                                      }}
                                    ></div>
                                  </div>
                                )}
                              </>
                            )
                          );
                        })}
                    </div>
                    {menu && menu.enable && menu.set.length > 0 && (
                      <div className="card-footer">
                        <div className="menu">
                          {menu.set.map((res2) => {
                            return this.createMapTableMenu(res, res2);
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          {place.map((res) => {
            return (
              <div
                className={`card place-holder  ${size} ${col} ${way} ${pos} ${menu && menu.enable ? "hasMenu" : ""
                  }`}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default BsyDashCard;
